// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='3'
    viewBox='0 0 16 3'
    ...attributes
  ><path
      fill='var(--icon-color, #000)'
      d='M7.75 2.843a1.46 1.46 0 0 1-1.5-1.421A1.46 1.46 0 0 1 7.75 0a1.46 1.46 0 0 1 1.5 1.421 1.46 1.46 0 0 1-1.5 1.422m6.25 0a1.46 1.46 0 0 1-1.5-1.421A1.46 1.46 0 0 1 14 0a1.46 1.46 0 0 1 1.5 1.421A1.46 1.46 0 0 1 14 2.843m-12.5 0A1.46 1.46 0 0 1 0 1.421 1.46 1.46 0 0 1 1.5 0 1.46 1.46 0 0 1 3 1.421a1.46 1.46 0 0 1-1.5 1.422'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'ThreeDotsHorizontal';
export default IconComponent;
